import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import VehicleForm from './VehicleForm';
import './Home.css';

const BuyersHome = () => {
    const handleSubmit = (formData) => {
        // Handle form submission
        console.log('Form submitted:', formData);
        // Redirect to create lead page with form data
        window.location.href = '/buyers/create_lead';
    };

    return (
        <main className="buyers-home">
            <section className="buyers-hero">
                <div className="hero-overlay">
                    <div className="container">
                        <div className="hero-content-wrapper">
                            <div className="hero-text">
                                <h1>Find Your Perfect Match Today</h1>
                                <p>Connect with verified sellers who have exactly what you're looking for. Get personalized matches and secure transactions, all in one place.</p>
                                <ul className="hero-benefits">
                                    <li>
                                        <FontAwesomeIcon icon={faCheckCircle} className="benefit-icon" />
                                        Verified sellers only
                                    </li>
                                    <li>
                                        <FontAwesomeIcon icon={faCheckCircle} className="benefit-icon" />
                                        No-pressure experience
                                    </li>
                                    <li>
                                        <FontAwesomeIcon icon={faCheckCircle} className="benefit-icon" />
                                        Secure payment handling
                                    </li>
                                </ul>
                            </div>

                            <div className="lead-form-container">
                                <div className="lead-form-header">
                                    <h2>Tell Us What You Want</h2>
                                    <p>Let us know what you're looking for and we'll match you with the right sellers.</p>
                                </div>
                                <VehicleForm onSubmit={handleSubmit} />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </main>
    );
};

export default BuyersHome;
